import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const useSearchResultsAdExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.SearchResultsAdExperiment,
        AmplitudeVariants.SearchResultsAdExperiment.NewDesign
    );
